import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, locationHandle, isWx, locationHandlev2, setImgsize } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import VueAudio from 'vue-audio';
// import 'vue-audio-player/dist/vueaudioplayer.css'
import QRCode from 'qrcodejs2';
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
import Index from "../smconfig/index.vue";
export default {
  name: 'enshizhoupop',
  data() {
    return {
      fid: this.$route.query.fid,
      popLeftArr: [{
        name: '简介',
        id: 0
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: '',
      infoList: [],
      videoUrl: '',
      videoitemflag: false,
      daohangflag: true,
      viewer: null,
      audiodescflag: false,
      audiodesc: null,
      timer: null,
      structList: [],
      structLabel: {},
      structImgdefaultValues: {},
      tabIndex: 0,
      introimg: '',
      introDesc: '',
      relatePic: [],
      relateVideo: [],
      relateAudio: [],
      mapculturalpersonList: [],
      // 非遗人列表数据 culturalHeritageInheritor202405192327
      culturalpersonform: {
        formId: 'cultural_heritage_inheritor',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142273459422eab738a2ef4681ff0d1e276d794a6b905f0918f3df30b1ce38395ba'
      },
      // 非遗人表单字段
      ewmflag: false,
      relateData: [],
      // 非遗项目传承人关联数据
      mapculturalprojectList: [],
      culturalform: {
        formId: 'cultural_heritage_project',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c'
      },
      // 非遗项目表单字段
      popDetail: {},
      relateinfoform: {
        formId: 'cultural_heritage_data',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c621423ee8dc727cfa10085597b1d197ac2543aa5084d3028db91d73d6a5f2391a6610'
      } // 非遗项目表单字段
    };
  },
  components: {
    VueAudio
  },
  props: ['detail', 'popshowflag', 'isMobile'],
  watch: {
    'detail'(val) {
      this.popDetail = val;
      if (val && Object.keys(val).length > 0) {
        for (const item of val.labelGroup) {
          item.flag = true;
          if (item.id === 0) this.getIntro(item.compt, val);
          if (item.id === 1 || item.id === 2) {
            this.getCulturalRelate(item.id, val.number);
            this.getInforRelate(item.id, val.number);
            return;
          }
          if (item.id === 3) {
            if (val[item.compt] === '' || val[item.compt].length === 0) {
              this.popDetail.labelGroup.forEach(item => {
                if (item.id === 3) item.flag = false;
              });
            } else {
              this.relatePic = val[item.compt];
            }
          }
          if (item.id === 4) {
            if (val[item.compt] === '' || val[item.compt].length === 0) {
              this.popDetail.labelGroup.forEach(item => {
                if (item.id === 4) item.flag = false;
              });
            } else {
              this.relateVideo = val[item.compt];
            }
          }
          if (item.id === 5) {
            if (val[item.compt] === '' || val[item.compt].length === 0) {
              this.popDetail.labelGroup.forEach(item => {
                if (item.id === 5) item.flag = false;
              });
            } else {
              this.relateAudio = val[item.compt].map(item => {
                item.title = item.name.replace(`.${item.suffix}`, '');
                this.$api.getUrlByObjectId(item.objectId).then(res => {
                  item.url = res.http;
                });
                return item;
              });
            }
          }
        }
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.tabIndex = 0;
      this.closevideoItem();
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoUrl = '';
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    goLocation(url) {
      this.popDetail.open = true;
      let obj = {};
      if (this.popDetail.correlation_address !== undefined) obj = {
        route: this.popDetail.correlation_address
      };
      if (this.popDetail.route !== undefined) obj = {
        route: this.popDetail.route
      };
      locationHandlev2.call(this, this.popDetail, obj);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.popDetail.linkTarget !== undefined && this.popDetail.linkTarget === '是') {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    },
    // 视频切换
    videoItemHandle(item) {
      this.videoitemflag = true;
      this.$api.getUrlByObjectId(item.objectId).then(res => {
        this.videoUrl = res.http;
      });
    },
    getImg(val) {
      return setImgsize(val, 160, 228);
    },
    /**
    * tabs选项卡点击事件
    * @date 2025-03-11
    */
    tabClick(item, index) {
      this.tabIndex = index;
      this.closevideoItem();
    },
    /**
    * 处理简介、封面图数据
    * @date 2025-03-10
    */
    getIntro(val, detail) {
      console.log(`val`, val);
      console.log(`detail`, detail);
      this.introimg = val.includes(',') ? detail[val.split(',')[1]].length > 0 ? detail[val.split(',')[1]][0].fileUrl : '' : '';
      this.introDesc = val.includes(',') ? detail[val.split(',')[0]] : detail[val];
    },
    /**
    * 获取对应非遗传承人或项目
    * @date 2025-03-10
    */
    getCulturalRelate(type, val) {
      if (val === '') return;
      let relateForm = {
        deptId: this.$route.query.fid,
        formId: 'cultural_heritage_relation',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142d757f00ba51fa091428641c34d726401671eb59a8d1473645f773212372283c1'
      };
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': type === 1 ? 'inheritor_number' : 'project_number',
            'compt': 'editinput',
            'express': '===',
            'val': val
          }]
        }]
      };
      relateForm.searchStr = encodeURI(JSON.stringify(searchStr));
      let that = this;
      this.$api.singleadvanceSearchv2(relateForm).then(res => {
        if (res.totalRow > 0) {
          res.dataList.forEach((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          that.relateData = res.dataList;
        }
      }).then(() => {
        if (that.relateData.length > 0) {
          let searchData = that.relateData.map(item => {
            return {
              'alias': 'number',
              'compt': 'autonumber',
              'express': '===',
              'val': type === 1 ? item.itemformdata.project_number : item.itemformdata.inheritor_number
            };
          });
          let searchStr = {
            model: 0,
            filters: [{
              "model": 1,
              "filters": searchData
            }]
          };
          if (type === 1) {
            this.culturalform.deptId = this.$route.query.fid;
            this.culturalform.searchStr = encodeURI(JSON.stringify(searchStr));
            this.$api.singleadvanceSearchv2(this.culturalform).then(res => {
              if (res.totalRow > 0) {
                that.mapculturalprojectList = that.formdataformat(res);
              } else {
                that.popDetail.labelGroup.forEach(item => {
                  if (item.id === type) item.flag = false;
                });
              }
            });
          }
          if (type === 2) {
            this.culturalpersonform.deptId = this.$route.query.fid;
            this.culturalpersonform.searchStr = encodeURI(JSON.stringify(searchStr));
            this.$api.singleadvanceSearchv2(this.culturalpersonform).then(res => {
              if (res.totalRow > 0) {
                that.mapculturalpersonList = that.formdataformat(res);
              } else {
                that.popDetail.labelGroup.forEach(item => {
                  if (item.id === type) item.flag = false;
                });
              }
            });
          }
        }
      });
    },
    formdataformat(res) {
      return res.dataList.map((item, index) => {
        let itemformdata = item.formIdValueData;
        let itemformat = {};
        Object.keys(itemformdata).forEach(key => {
          itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
        });
        item.itemformdata = itemformat;
        return item;
      });
    },
    /**
    * 跳转详情
    * @date 2025-03-14
    */
    godetail(url) {
      if (!url.includes('http')) url = `${location.protocol}//${url}`;
      window.open(url);
    },
    /**
    * 获取分享链接
    * @date 2025-03-14
    */
    getCode() {
      this.ewmflag = true;
      if (document.querySelector('.qrcode-share img')) return;
      new QRCode(this.$refs['qrcode-share'], {
        text: this.popDetail.detailUrl,
        // 扫二维码后获得的信息
        width: 280,
        // 图片宽90px，左右padding各4px，边框各1px， 100-8px-2px
        height: 280,
        // 图片高90px，上下padding各4px，边框各1px， 100-8px-2px
        correctLevel: 3
      });
    },
    /**
    * 获取项目、传承人 相关资料
    * @param {Number} type 1传承人 2项目
    * @param {String} number 传承人或项目编号
    * @date 2025-03-20
    */
    getInforRelate(type, number) {
      let that = this;
      let searchStr = {
        model: 0,
        filters: [{
          "model": 0,
          "filters": [{
            'alias': type === 1 ? 'inheritor_number' : 'project_number',
            'compt': 'editinput',
            'express': '===',
            'val': number
          }]
        }]
      };
      let allData = [];
      let totalPage = 1;
      this.relateinfoform.deptId = this.$route.query.fid;
      this.relateinfoform.searchStr = encodeURI(JSON.stringify(searchStr));
      async function getList() {
        if (that.relateinfoform.page > totalPage) {
          that.formatInfor(allData);
          return;
        }
        await that.$api.singleadvanceSearchv2(that.relateinfoform).then(res => {
          totalPage = res.totalPage;
          if (totalPage && totalPage >= that.relateinfoform.page) {
            const dataList = that.formdataformat(res);
            allData = allData.concat(dataList);
            that.relateinfoform.page++;
            getList();
          }
        });
      }
      getList();
    },
    formatInfor(data) {
      this.relatePic = [];
      this.relateVideo = [];
      this.relateAudio = [];
      data.forEach(item => {
        if (item.itemformdata.data_type === '图片') this.relatePic.push(...item.itemformdata.image);
        if (item.itemformdata.data_type === '视频') this.relateVideo.push(...item.itemformdata.video);
        if (item.itemformdata.data_type === '音频') this.relateAudio.push(...item.itemformdata.audio);
      });
      this.popDetail.labelGroup.forEach(item => {
        if (item.id === 3) item.flag = this.relatePic.length !== 0;
        if (item.id === 4) item.flag = this.relateVideo.length !== 0;
        if (item.id === 5) item.flag = this.relateAudio.length !== 0;
      });
    }
  }
};